module.exports = __webpack_public_path__ + "img/q1-eccentric.f4b9e519.svg";